/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Position_Modal_Description_SelectedInputs */



/**
* | output |
* | --- |
* | "selected" |
*
* @param {Position_Modal_Description_SelectedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const position_modal_description_selected = /** @type {((inputs?: Position_Modal_Description_SelectedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Position_Modal_Description_SelectedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("selectionnes")
	if (locale === "de") return /** @type {LocalizedString} */ ("ausgewählt")
	if (locale === "it") return /** @type {LocalizedString} */ ("selezionato")
	if (locale === "ru") return /** @type {LocalizedString} */ ("выбранный")
	if (locale === "es") return /** @type {LocalizedString} */ ("seleccionado")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("选定")
	if (locale === "ja") return /** @type {LocalizedString} */ ("選択された")
	if (locale === "hi") return /** @type {LocalizedString} */ ("चयनित")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("selecionado")
	return /** @type {LocalizedString} */ ("selected")
});